import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router'
import { parseAuthQuery, stringifyAuthQuery } from '@/lib/authQuery'
import { BACK_URL_QUERY_KEY, resolveNavigationBackUrl } from '@/lib/backUrl'
import { AUTH_PUBLIC_BASE } from '@/lib/paths'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/features/login/Cc3AuthLoginPage.vue'),
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/features/registration/Cc3AuthRegistrationPage.vue'),
  },
  {
    path: '/registration/invitation',
    name: 'registration-invitation',
    component: () =>
      import('@/features/registration/Cc3AuthRegistrationInvitationPage.vue'),
  },
  {
    path: '/registration/final',
    name: 'registration-final',
    component: () =>
      import('@/features/registration/Cc3AuthRegistrationFinalPage.vue'),
  },
  {
    path: '/registration/success',
    name: 'registration-success',
    component: () =>
      import('@/features/registration/Cc3AuthRegistrationSuccessPage.vue'),
  },
  {
    path: '/recovery',
    name: 'recovery',
    component: () => import('@/features/recovery/Cc3AuthRecoveryPage.vue'),
  },
  {
    path: '/recovery/linkSending',
    name: 'recovery-linkSending',
    component: () => import('@/features/recovery/Cc3AuthRecoveryLinkPage.vue'),
  },
  {
    path: '/recovery/changePass',
    name: 'recovery-changePass',
    component: () =>
      import('@/features/recovery/Cc3AuthRecoveryChangePassPage.vue'),
  },
  {
    path: '/recovery/success',
    name: 'recovery-success',
    component: () =>
      import('@/features/recovery/Cc3AuthRecoverySuccessPage.vue'),
  },
  {
    path: '/activate',
    name: 'activate',
    component: () => import('@/features/activate/Cc3AuthActivatePage.vue'),
  },
  {
    path: '/activate/create',
    name: 'activate-create',
    component: () =>
      import('@/features/activate/Cc3AuthActivateCreatePage.vue'),
  },
  {
    path: '/activate/isReg',
    name: 'activate-isReg',
    component: () => import('@/features/activate/Cc3AuthActivateIsRegPage.vue'),
  },
  {
    path: '/activate/linkSending',
    name: 'activate-linkSending',
    component: () =>
      import('@/features/activate/Cc3AuthActivateLinkPage.vue'),
  },
  {
    path: '/activate/success',
    name: 'activate-success',
    component: () =>
      import('@/features/activate/Cc3AuthActivateSuccessPage.vue'),
  },
  {
    path: '/verifyDone',
    name: 'verifyDone',
    component: () => import('@/features/activate/Cc3AuthVerifyDonePage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: () => import('@/features/error/Cc3AuthErrorPage.vue'),
  },
]

export function installBackUrlGuard(
  target: ReturnType<typeof createRouter>,
): void {
  target.beforeEach((to, from) => {
    if (to.query[BACK_URL_QUERY_KEY]) return true

    const fromRaw = from.query[BACK_URL_QUERY_KEY]
    const fromHint = Array.isArray(fromRaw) ? fromRaw[0] : fromRaw
    const back = resolveNavigationBackUrl(
      typeof fromHint === 'string' ? fromHint : null,
    )
    if (!back) return true

    return {
      ...to,
      query: { ...to.query, [BACK_URL_QUERY_KEY]: back },
    }
  })
}

export const router = createRouter({
  history: createWebHistory(AUTH_PUBLIC_BASE),
  routes,
  scrollBehavior: () => ({ top: 0 }),
  stringifyQuery: stringifyAuthQuery,
  parseQuery: parseAuthQuery,
})

installBackUrlGuard(router)
